// extracted by mini-css-extract-plugin
var _1 = "MenuItem_content__fde20";
var _2 = "MenuItem_disabled__cce2a";
var _3 = "MenuItem_fluid__76cb2";
var _4 = "MenuItem_group__2c032";
var _5 = "MenuItem_groupLabel__718f2";
var _6 = "MenuItem_horizontal__fb092";
var _7 = "MenuItem_hovered__24e75";
var _8 = "MenuItem_label__f0575";
var _9 = "MenuItem_large__f5bd4";
var _a = "MenuItem_medium__574ae";
var _b = "MenuItem_mini__25edf";
var _c = "MenuItem_remove__c228d";
var _d = "MenuItem_root__c4da0";
var _e = "MenuItem_selected__42d50";
var _f = "MenuItem_xmini__2d849";
export { _1 as "content", _2 as "disabled", _3 as "fluid", _4 as "group", _5 as "groupLabel", _6 as "horizontal", _7 as "hovered", _8 as "label", _9 as "large", _a as "medium", _b as "mini", _c as "remove", _d as "root", _e as "selected", _f as "xmini" }
